import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'ascential-horizon'
import dompurify from 'dompurify'
import ReactPlayerLoader from '@brightcove/react-player-loader'
import getThemeConfig from '../../providers/config/themeConfig'
import { trackBtnClick } from '../../services/tracking'
import {
  BrightCoveContainer,
  StyledPlayer,
  VideoOverlay,
} from './LivePlayer.style'

// For the Brightcove Player the URL prop MUST contain only the videoId, ex. 6258950085001
function VideoEmbed({
  hasVotemo,
  isAuthorized,
  login,
  loggedIn,
  splitLogic,
  url,
}) {
  const {
    videoPlatform: {
      featuredVideoOverlay: { button, title, titleAuth, sponsorLogo },
      livePlayer,
    },
  } = getThemeConfig()
  const santizer = dompurify.sanitize

  const buttonUrl = loggedIn && !isAuthorized ? button.link : '#'
  const buttonText = loggedIn && !isAuthorized ? button.textAuth : button.text
  const overlayText = loggedIn && !isAuthorized ? titleAuth : title

  function handleClick(e, label, trackUrl) {
    trackBtnClick(label, trackUrl)

    if (loggedIn && !isAuthorized) {
      return
    }

    e.preventDefault()
    if (!loggedIn && typeof login === 'function') {
      login()
    }
  }
  return (
    <StyledPlayer splitSize={splitLogic} hasVotemo={hasVotemo}>
      {!isAuthorized && (
        <VideoOverlay>
          {sponsorLogo && <img src={sponsorLogo} alt="Sponsor Logo" />}
          <Button
            variant={button.variant}
            onClick={(e) => handleClick(e, buttonText, '#')}
            url={buttonUrl}>
            {buttonText}
          </Button>
          <div dangerouslySetInnerHTML={{ __html: santizer(overlayText) }} />
        </VideoOverlay>
      )}

      {livePlayer === 'brightcove' ? (
        <BrightCoveContainer>
          <ReactPlayerLoader
            style={{ width: '100%', height: '100%' }}
            accountId="6253422315001"
            playerId="HFV4L2yaX"
            videoId={url}
          />
        </BrightCoveContainer>
      ) : (
        <iframe
          title="Live Feed"
          width="100%"
          height="100%"
          src={url}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </StyledPlayer>
  )
}

VideoEmbed.propTypes = {
  isAuthorized: PropTypes.bool,
  login: PropTypes.func,
  loggedIn: PropTypes.bool,
  splitLogic: PropTypes.bool,
  url: PropTypes.string.isRequired,
  hasVotemo: PropTypes.bool,
}

VideoEmbed.defaultProps = {
  hasVotemo: false,
  isAuthorized: false,
  loggedIn: false,
  splitLogic: false,
  login: () => {},
}

export default VideoEmbed
